export default {
  title: "Обратная связь",

  nameField: "Как Вас зовут?",
  phoneField: "Контактный телефон",
  messageField: "Текст обращения",

  send: "Отправить",
  sentSuccess: "Успешно отправлено",

  errors: {
    send_error: "Ошибка отправки сообщения",
    added_error: "Ошибка создания обращения",
    server: "Серверная ошибка. Попробуйте позже."
  }
};
